import './input-item.scss';

const variants = {
	default: 'input-item--default',
	ghost: 'input-item--ghost',
};

interface InputItemParams {
	variant?: keyof typeof variants;
	onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
	value?: string | number;
	placeholder?: string;
	type?: React.HTMLInputTypeAttribute;
	label?: string;
	disabled?: boolean;
	min?: string;
	style?: React.CSSProperties;
	iconRight?: string;
}

export const InputItem = ({ label, disabled, onChange, variant = 'default', iconRight, ...props }: InputItemParams) => {
	return (
		<div className={`input-item ${variants[variant]}`}>
			{label && (
				<label className="input-item__label" htmlFor={String(label)}>
					{label}
				</label>
			)}
			<input
				onChange={onChange}
				id={label && String(label)}
				className="input-item__control"
				disabled={disabled}
				{...props}
			/>
			{iconRight && <img src={iconRight} alt="" />}
		</div>
	);
};
